const contactDefaultSubject = document.querySelector('[data-contact-subject-default]');

const setDefaultContactFormSubject = () => {
  const defaultSubjectId = contactDefaultSubject.dataset.contactSubjectDefault;
  const contactSubjectField = document.querySelector('#block-contactform select[name="subject"]');

  if (!defaultSubjectId || defaultSubjectId.length === 0 || !contactSubjectField) {
    return;
  }
  contactSubjectField.value = defaultSubjectId;
};

contactDefaultSubject && setDefaultContactFormSubject();
